import {useLocalStorage} from "../../../hooks/useLocalStorage";
import SvgConsole from "../../../svg/SvgConsole";
import {relativeDateAndTime} from "../../../util/timeConverter";
import {LucidePlug, LucideUnplug} from "lucide-react";
import {useOverlay} from "../overlay/OverlayContext";
import {useEffect, useState} from "react";
import {doFetch} from "../../../util/fetch";

export default function AuditLog(){

    const [serverId, ] = useLocalStorage('serverId')
    const [auditLog, setAuditLog] = useState<AuditLogData>()

    const overlay = useOverlay()

    useEffect(() => {
        doFetch<AuditLogData>(`/api/client/auditLog?serverId=${serverId}`).then(r => {
            if (r.ok){
                setAuditLog(r.data)
            }
            else if (r.error){
                overlay.openErrorOverlay(r.error)
            }
        })
        // Don't add overlay dep -> will cause infinite loop
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serverId]);

    return (
        <div className="size-full flex flex-col sm:p-4">

            <div className="overflow-x-auto space-y-2 w-max">
                {auditLog && auditLog.entries.map((entry, i) => renderLogEntry(entry, i))}
            </div>

        </div>
    )
}

function renderLogEntry(entry: AuditLogEntry, key: number){
    return (
        <div className="p-4 rounded-md bg-neutral-900" key={key}>
            <div className="inline-flex items-center space-x-2">
                {renderEntryContents(entry)}
            </div>
            <div className="text-neutral-400 text-xs">{relativeDateAndTime(entry.timestamp)}</div>
        </div>
    );
}

// DO NOT CHANGE ORDER
enum AuditLogEntryType {
    NONE,
    CONSOLE_COMMAND,
    SERVER_CONNECTION,
    PLAYER_KICK,
    PLAYER_BAN,
    IP_BAN,
    PLAYER_UNBAN,
    IP_UNBAN
}

function renderEntryContents(entry: AuditLogEntry){
    if (entry.type === AuditLogEntryType.CONSOLE_COMMAND){
        return (
            <>
                <SvgConsole size={24} className="inline-block text-yellow-400"/>
                <span>{entry.user.steamName}</span>
                <span className="text-neutral-400">ran command</span>
                <span className="font-mono bg-neutral-700 px-2 rounded-md">{entry.data}</span>
            </>
        )
    }
    if (entry.type === AuditLogEntryType.SERVER_CONNECTION){
        return (
            <>
                {entry.data === "1" ? <LucidePlug color="green" /> :
                    <LucideUnplug color="red" />}
                <span>Server connection {(entry.data === "1" ? "established" : "lost")}</span>
            </>
        )
    }
    if (entry.type === AuditLogEntryType.PLAYER_KICK){
        // TODO add other entry types
    }

    return (
        <>
            <span>{entry.user.steamName}</span>
            <span className="text-neutral-400">ran action</span>
            <span>#{entry.type}</span>
            <span className="text-neutral-400">with data</span>
            <span className="font-mono bg-neutral-700 p-1 rounded-md">{entry.data}</span>
        </>
    )
}

interface AuditLogData {
    entries: AuditLogEntry[]
}

interface AuditLogEntry {
    timestamp: number
    type: AuditLogEntryType
    user: { steamName: string; steamId: string }
    data?: string
}